import { Box, HStack, SimpleGrid, Stack } from '@chakra-ui/react';
import type { ShiptoDepositCrud } from '@diamond/shared/schema/shipto-deposit';
import { Text } from '@diamond/shared/ui';
import {
  buyerCurrencyFormatter,
  paymentMethodFormatter,
} from '@diamond/shared/utils';
import { formatNlbUpdatedAt } from '@diamond/sol-buyer/utils';
import { useNlbRedDotIndicator } from '@diamond/sol-buyer-context';
import { UpdateOutlined } from '@mui/icons-material';

import { NlbRedDotBadge } from '../NlbRedDotBadge';

export interface PaymentInfoSidebarProps {
  paymentMethod: string;
  balance?: ShiptoDepositCrud['getBalance']['response'];
  showNlbBalance: boolean;
}

function SidebarField({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <Box>
      <Text color="azure" fontSize="14px" fontWeight="normal">
        {label}
      </Text>
      {children}
    </Box>
  );
}

export function PaymentInfoSidebar({
  paymentMethod,
  balance,
  showNlbBalance,
}: PaymentInfoSidebarProps) {
  const { showRedDot } = useNlbRedDotIndicator();

  return (
    <Stack spacing={6}>
      <SimpleGrid
        columns={1}
        spacing={6}
        fontSize={{ base: '14px', md: '16px' }}
      >
        <SidebarField label="Metode Pembayaran">
          <Text fontSize={{ base: '14px', md: '20px' }}>
            {paymentMethodFormatter(paymentMethod)}
          </Text>
        </SidebarField>
        {showNlbBalance ? (
          <>
            <Box>
              <Box position="relative" display="inline-block" mb={1}>
                <Text color="azure" fontSize="14px" fontWeight="normal">
                  Nominal Lebih Bayar
                </Text>
                {showRedDot ? (
                  <Box display={{ base: 'block', md: 'none' }}>
                    <NlbRedDotBadge top="-2px" right="-14px" />
                  </Box>
                ) : null}
              </Box>
              <Text fontSize={{ base: '24px', md: '24px' }} fontWeight="medium">
                {buyerCurrencyFormatter(balance?.available_balance ?? 0)}
              </Text>
            </Box>
            <Box display={{ base: 'none', md: 'block' }}>
              <SidebarField label="Diperbarui">
                <Text fontSize={{ base: '14px', md: '16px' }}>
                  {formatNlbUpdatedAt(balance?.last_updated_at)}
                </Text>
              </SidebarField>
            </Box>
            <HStack
              spacing={2}
              display={{ base: 'flex', md: 'none' }}
              align="center"
            >
              <UpdateOutlined
                style={{ fontSize: 16, color: '#8e8e93' }}
                aria-hidden
              />
              <Text fontSize="xs" color="#8e8e93">
                Diperbarui
              </Text>
              <Text fontSize="xs" color="black">
                {formatNlbUpdatedAt(balance?.last_updated_at)}
              </Text>
            </HStack>
            <Text fontSize="sm" color={{ base: '#ff8d28', md: 'gray.600' }}>
              Hanya dapat digunakan pada metode pembayaran Bank Transfer
            </Text>
          </>
        ) : null}
      </SimpleGrid>
    </Stack>
  );
}
